import React from "react";

const Padlock = ({ fill, width }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.011 17.3121V13.4031C30.011 8.82779 26.3004 5.11727 21.7251 5.11727C17.1498 5.09724 13.4247 8.78956 13.4046 13.3667V13.4031V17.3121"
      stroke={fill}
      strokeWidth="2.731"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.6633 38.7965H14.7516C10.9391 38.7965 7.84763 35.7068 7.84763 31.8925V24.0837C7.84763 20.2694 10.9391 17.1797 14.7516 17.1797H28.6633C32.4758 17.1797 35.5673 20.2694 35.5673 24.0837V31.8925C35.5673 35.7068 32.4758 38.7965 28.6633 38.7965Z"
      stroke={fill}
      strokeWidth="2.731"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7079 25.9688V30.0125"
      stroke={fill}
      strokeWidth="2.731"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Padlock.defaultProps = {
  width: 8,
  fill: "black",
};

export default Padlock;
